/**
 * tol-header-cart-link.js
 *
 * 契約（2026-10-20 No.6 改：全画面幅に拡大）
 * - 読み込み条件: settings.cart_type == 'drawer' のときのみ（sections/header.liquid）。
 * - ヘッダーのカートアイコン（#cart-icon-bubble）を押したときだけ、Dawn 標準 cart-drawer.js の
 *   ドロワー展開を止め、<a href="{{ routes.cart_url }}"> の通常遷移（/cart）に任せる。
 *   PC・SP とも対象（旧仕様は SP 989px 以下のみ）。
 * - それ以外のドロワー動作（カート追加後の自動オープン、ドロワー内の数量変更・削除など）は一切変更しない。
 * - cart-drawer.js と header.liquid のマークアップは無改修。window の capture 段階でイベントを止めるため、
 *   cart-drawer.js が #cart-icon-bubble に付けるリスナーより必ず先に動く。
 * - #cart-icon-bubble はカート操作時に innerHTML のみ入れ替わる（要素自体は残る）が、
 *   本ファイルは closest() で毎回判定するため影響を受けない。
 */
(function () {
  'use strict';

  var SELECTOR = '#cart-icon-bubble';

  function findCartLink(target) {
    return target && target.closest ? target.closest(SELECTOR) : null;
  }

  // クリック（マウス・タップ・Enter キー由来の click を含む）:
  // cart-drawer.js の preventDefault + open() に届く前に止め、リンク本来の遷移を活かす。
  window.addEventListener(
    'click',
    function (event) {
      if (!findCartLink(event.target)) return;
      event.stopImmediatePropagation();
    },
    true
  );

  // Space キー: cart-drawer.js は role="button" 扱いで Space でもドロワーを開くため、それも止める。
  // （下でリンクの意味付けに戻すので、Space はブラウザ標準のリンク挙動になる）
  window.addEventListener(
    'keydown',
    function (event) {
      if (event.code !== 'Space' && event.key !== ' ') return;
      if (!findCartLink(event.target)) return;
      event.stopImmediatePropagation();
    },
    true
  );

  // cart-drawer.js が付与する role="button" / aria-haspopup="dialog" を外し、
  // 支援技術にも「ページへのリンク」として伝える。
  function restoreLinkSemantics() {
    var link = document.querySelector(SELECTOR);
    if (!link) return;
    link.removeAttribute('role');
    link.removeAttribute('aria-haspopup');
  }

  if (window.customElements && typeof window.customElements.whenDefined === 'function') {
    window.customElements.whenDefined('cart-drawer').then(restoreLinkSemantics);
  }
})();